export default __webpack_public_path__ + "static/profile-41e904db9bc8549f8a3456ad93b34d6f.jpg";